export default __webpack_public_path__ + "locales/pt/InviteDialog.json?hash=342afe344892f0398362bc682a6afe6f";